<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{ year }}
    <a href="https://gaspesie.net" target="_blank">InteliSoft Informatique inc.</a></strong> Tous droits réservés.
  </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashFooter.vue?f5a5054e